<template>
    <div class="flex flex-row items-center gap-2 md:gap-4 p-1 md:p-3">
        <MiscIcon
            class="w-[88px] h-[88px] p-3 text-new"
            size="none"
            :name="content.data?.iconName"
        />
        <div class="text-xl font-semibold leading-6">
            <MiscModal
                v-if="content.data?.modalHeadline != ''"
            >
                <template #button>
                    <div 
                        class="text-link text-left" 
                    >
                        {{ content.data?.text }}
                    </div>
                </template>
                <template #content>
                    <h3 class="font-bold text-3xl text-link">
                        {{ content.data?.modalHeadline }}
                    </h3>
                    <p class="py-4 text-lg">
                        {{ content.data?.modalText }}
                    </p>
                </template>
            </MiscModal>
            <div v-else class="text-link">
                {{ content.data?.text }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot,
}>()
</script>